import { LabelType } from '@softline/application';

export function isCustomerCard(value: string, labelType = 'code39' as LabelType | null) {
  return (
    ((labelType === 'code39' || labelType === 'code128') &&
      (value.toLowerCase().startsWith('kk') || value.toLowerCase().startsWith('kto'))) ||
    value.startsWith('8011')
  );
}
